// Mock data for Wonderman Bookkeeping website
// This data can be easily edited or replaced with backend data later

export const businessInfo = {
  name: "Wonderman Bookkeeping",
  tagline: "Bringing Clarity to Your Finances",
  phone: "079424648658",
  email: "Da4adindu@gmail.com",
  logo: "https://customer-assets.emergentagent.com/job_bookwise-hub-6/artifacts/s2a0s0u4_ChatGPT%20Image%20Jan%2020%2C%202026%2C%2005_04_03%20PM.png"
};

export const services = [
  {
    id: 1,
    title: "Monthly Bookkeeping",
    description: "Keep your finances organised with regular, accurate bookkeeping. We handle all your day-to-day transactions so you can focus on running your business.",
    features: ["Transaction categorisation", "Bank reconciliation", "Monthly financial summaries", "Cloud-based access"]
  },
  {
    id: 2,
    title: "Bank Reconciliations",
    description: "Ensure your records match your bank statements perfectly. We catch discrepancies early and keep your accounts accurate.",
    features: ["Regular statement matching", "Error identification", "Detailed reconciliation reports", "Multi-account support"]
  },
  {
    id: 3,
    title: "Payroll Support",
    description: "From calculating wages to filing RTI submissions, we handle the complexities of payroll so your team gets paid on time, every time.",
    features: ["Wage calculations", "PAYE & NI management", "RTI submissions", "Payslip generation"]
  },
  {
    id: 4,
    title: "Cleanup & Catch-Up",
    description: "Behind on your books? No judgement here. We'll get your records up to date and organised, no matter how far behind you've fallen.",
    features: ["Historical data entry", "Account restructuring", "Error corrections", "Fresh start setup"]
  },
  {
    id: 5,
    title: "Financial Reporting",
    description: "Clear, easy-to-understand reports that show you exactly where your business stands. Make informed decisions with confidence.",
    features: ["Profit & Loss statements", "Balance sheets", "Cash flow reports", "Custom reporting"]
  },
  {
    id: 6,
    title: "VAT Returns",
    description: "MTD-compliant VAT submissions handled accurately and on time. Never worry about missing a deadline again.",
    features: ["MTD compliance", "Quarterly submissions", "VAT scheme advice", "HMRC liaison"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    business: "Mitchell Design Studio",
    rating: 5,
    text: "Wonderman Bookkeeping transformed my chaotic finances into a well-organised system. I finally understand where my money goes, and tax time is no longer stressful. Highly recommend!"
  },
  {
    id: 2,
    name: "James Okonkwo",
    business: "JO Consulting Ltd",
    rating: 5,
    text: "Professional, reliable, and incredibly easy to work with. They caught errors my previous bookkeeper missed and saved me money in the process. Worth every penny."
  },
  {
    id: 3,
    name: "Emma Richardson",
    business: "Freelance Marketing Consultant",
    rating: 5,
    text: "As a freelancer, I dreaded doing my own books. Now I send everything to Wonderman and it's handled perfectly. They explain things in plain English, which I really appreciate."
  },
  {
    id: 4,
    name: "David Chen",
    business: "Chen's Catering Services",
    rating: 5,
    text: "They helped me catch up on two years of neglected bookkeeping without making me feel judged. Now I'm completely organised and actually enjoy looking at my financial reports."
  }
];

export const faqs = [
  {
    id: 1,
    question: "What's the difference between bookkeeping and accounting?",
    answer: "Bookkeeping involves recording and organising your daily financial transactions—things like sales, purchases, and payments. Accounting takes that data further, using it to analyse your business performance, prepare tax returns, and provide strategic financial advice. Think of bookkeeping as the foundation that good accounting is built upon."
  },
  {
    id: 2,
    question: "How often should I update my books?",
    answer: "Ideally, your books should be updated regularly—weekly or at least monthly. This keeps you aware of your cash flow, helps catch errors early, and makes tax time much less stressful. We recommend monthly bookkeeping for most small businesses."
  },
  {
    id: 3,
    question: "What software do you work with?",
    answer: "We're QuickBooks Pro Advisors and work extensively with QuickBooks Online. We also support Xero, FreeAgent, and other popular cloud accounting platforms. If you're not sure which software is right for you, we can help you choose."
  },
  {
    id: 4,
    question: "What is Making Tax Digital (MTD)?",
    answer: "Making Tax Digital is a UK government initiative requiring businesses to keep digital records and submit tax returns using compatible software. We're fully MTD-ready and can ensure your business stays compliant with all HMRC requirements."
  },
  {
    id: 5,
    question: "How do you keep my financial information secure?",
    answer: "Your data security is our top priority. We're AML compliant and registered with both HMRC and ICB. We use encrypted, cloud-based systems, follow strict data protection protocols, and never share your information with third parties."
  },
  {
    id: 6,
    question: "What if I'm behind on my bookkeeping?",
    answer: "Don't worry—you're not alone, and we're here to help without judgement. Our cleanup and catch-up service is designed specifically for businesses that have fallen behind. We'll get your records organised and up to date, then help you stay on track going forward."
  },
  {
    id: 7,
    question: "How much do your services cost?",
    answer: "Our pricing depends on the size and complexity of your business, as well as the services you need. We offer transparent, fixed-fee packages so you always know what you're paying. Get in touch for a free, no-obligation quote tailored to your needs."
  }
];

export const certifications = [
  {
    id: 1,
    name: "QuickBooks Pro Advisor",
    description: "Certified QuickBooks specialist"
  },
  {
    id: 2,
    name: "MTD Ready",
    description: "Making Tax Digital compliant"
  },
  {
    id: 3,
    name: "AML Registered",
    description: "Registered with HMRC & ICB"
  }
];
